<template>
  <section>
    <b-input v-model="value.data" type="textarea"/>
  </section>
</template>

<script>
export default {
  name: 'c-textarea',
  props: ['value', 'type'],
}
</script>



// WEBPACK FOOTER //
// src/lib/components/Textarea.vue